import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the GarminlivePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-garminlive',
  templateUrl: 'garminlive.html',
})
export class GarminlivePage {

  VehicleID = ''
  garminQuickMessages = []
  vehiclesGarminComm = []
  _enterpredmess = ''
  _messforall = false
  _vehGarmin = '-1'
  _vehName = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    this.VehicleID = navParams.get('vid')
    this._vehName = navParams.get('reg') + ' (' + navParams.get('code') + ')'
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GarminlivePage');
    this.loadGarminQuickMessages();
  }

  loadGarminQuickMessages() {
    var _that = this
    this.gn._Post('/api/gn/getallgarminquickemessages', { vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      _that.garminQuickMessages = _data
      _that.gn._Post('/api/gn/getallvehiclesgarmincomm', { vid: _that.gn.crypt(_that.VehicleID), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), rid: _that.gn.crypt(_that.gn.user.RoleId) }, function (_data1) {
        _that.vehiclesGarminComm = _data1
      })
    })
  }

  DeleteQuickmessClick(_messid, _gsm) {
    var _that = this
    let confirm = this.alertCtrl.create({
      title: 'Бришење предефинирана порака',
      message: 'Дали сте сигурни дека сакате да ја избришете оваа предефинирана порака?',
      buttons: [
        {
          text: this.dic.l["NO"],
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: this.dic.l["YES"],
          handler: () => {
            var _dat = {
              messid: _that.gn.crypt(_messid),
              gsm: _that.gn.crypt(_gsm)
            }
            _that.gn._Post('/api/gn/deleteQuickMess', _dat, function (_data) {
              //
            })
          }
        }
      ]
    });
    confirm.present();
  }

  addQuickMess(_from) {
    var isCheck = false;
    var _toid = '';
    var _text = '';
    if (_from == '0') {
      isCheck = this._messforall
      _text = this._enterpredmess;
      if (_text == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["entergarminmess"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    } else {
      if (this._vehGarmin == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["choosegarminvehicle"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      _text = this.gn.Vehicles[this.gn.VehiclesDic[this._vehGarmin]].registration + ': ';
      _toid = this._vehGarmin
    }
    var _that = this
    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      rid: this.gn.crypt(this.gn.user.RoleId),
      vehid: this.gn.crypt(this.VehicleID),
      allcheck: this.gn.crypt(isCheck),
      toid: this.gn.crypt(_toid),
      name: this.gn.crypt(_text)
    }
    _that.gn._Post('/api/gn/addQuickmess', _dat, function (_data) {
      _that.loadGarminQuickMessages();
      _that._enterpredmess = ''
      _that._messforall = false
      _that._vehGarmin = '-1'
    })
    //debugger
    // $.ajax({
    //     url: twopoint + "/main/AddCanned.php?action=add&vehid=" +_id + "&allcheck=" + isCheck + "&toid=" + _toid + "&name=" + kescape(_text) + "&tpoint=" + twopoint,
    //     context: document.body,
    //     success: function (data) {
    //         if(ws != null) {
    //             if(isCheck) {
    //                 var result = data.replace(/\r/g, '').replace(/\n/g, '');
    //                 result = result.split('*');
    //                 for(var i=1; i<result.length; i++) {
    //                     ws.emit('quickmess', result[i].split('|')[0] + '$*^' + _text + '$*^' + result[i].split('|')[1]);
    //                 }
    //             } else {
    //                 ws.emit('quickmess', _gsmnum + '$*^' + _text + '$*^' + data.replace(/\r/g, '').replace(/\n/g, ''));
    //             }
    //             $('#predefmess').load('../main/PredefinedMess.php?id=' + _id, function(){
    //                 $("#txtCannedReg").load('../tracking/garminReloadReg.php?id=' + _id + "&l=" + lang, function(){
    //                     HideWait();
    //                 });
    //             });
    //         }
    //     }
    // });
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapview/garminlive/garminlive.ts